import type { CustomNodeData, CustomNode, CustomEdge } from '@src/components/custom-nodes/types';
import type { RenderPlaceholdersProps } from './types';
import { getPlaceholder } from './nodes-factory';
import { getNodesWithoutPlaceholders, getValidIfStatementPositions } from '../utils';
import { getValidGotoStatementPositions } from '../utils/get-valid-goto-statement-nodes';

const getLastNodesInEachBranch = (nodes: CustomNode[], edges: CustomEdge[]) => {
  const finishNode = nodes.find((node) => node.type === 'FinishNode');
  const lastNodeIds = edges.filter((edge) => edge.target === finishNode?.id).map((edge) => edge.source);
  const lastNodes = nodes.filter((node) => lastNodeIds.includes(node.id));

  return lastNodes;
}


export const renderLastPlaceholder = (
  nodes: CustomNode[],
  edges: CustomEdge[],
  {
    visible=false,
    onlyLast=false,
    onlyAfterMultiple=false
  }: RenderPlaceholdersProps) => {
  const nodesWithoutPlaceholder = getNodesWithoutPlaceholders(nodes);
  const nodesWithBottomHandles = nodesWithoutPlaceholder.filter(node => (node.data as CustomNodeData)?.handles?.b);
  const nodesWithoutIfConditions = nodesWithBottomHandles.filter(node =>  !['if:condition', 'if:condition-behavior'].includes((node.data as CustomNodeData)?.nodeType ?? ''));

  if (!nodesWithBottomHandles.length) {
    return nodesWithoutPlaceholder;
  }

  let nodesToProcess = nodesWithoutIfConditions;

  const dndItemNode = JSON.parse(localStorage.getItem('dndItem') ?? '{}') as CustomNodeData;

  if (onlyLast) {
    nodesToProcess = getLastNodesInEachBranch(nodes, edges);
  }

  if (onlyAfterMultiple) {
    let searchNodes = nodes;
    // get the nodes that are message:multi
    if (onlyLast) {
      searchNodes = getLastNodesInEachBranch(nodes, edges);
    }
    const multipleNodes = searchNodes.filter((node) => (node.data as CustomNodeData).nodeType === 'message:multi')

    nodesToProcess = multipleNodes;
  }

  if (dndItemNode?.nodeType === 'if:condition') {
    const validNodesToPutCondition = getValidIfStatementPositions(nodesToProcess, nodes, edges);
    nodesToProcess = validNodesToPutCondition;
  }

  if (dndItemNode?.nodeType === 'message:goto') {
    const validNodesToPutGoto = getValidGotoStatementPositions(nodesToProcess, nodes);
    nodesToProcess = validNodesToPutGoto;
  }

  nodesToProcess = nodesToProcess.filter(node => (node.data as CustomNodeData)?.nodeType !== 'message:goto');

  const resultingNodes = nodesToProcess.reduce((acc, node) => {
    const lastPlaceholder = getPlaceholder({
      position: node.position,
      previousNodeHeight: node.height,
      height: 50,
      isPlaceholderVisible: visible,
      branchId: node.branchId,
      parentBranchId: node.parentBranchId,
      parentNodeId: node.id,
    });

    return acc.concat(lastPlaceholder);
  }, nodesWithoutPlaceholder);

  return resultingNodes;
}
